// material-ui
import { useMediaQuery, useTheme } from '@mui/material';

// project-imports
import NavCard from './NavCard';
import Navigation from './Navigation';
import SimpleBar from '../../../../atoms/SimpleBar';
import { useSelector } from '../../../../../state';
import React from 'react';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  const { drawerOpen } = useSelector((state) => state.menuState);

  return (
    <SimpleBar
      sx={{
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <>
        <Navigation />
        {drawerOpen && !matchDownMD && <NavCard />}
      </>
    </SimpleBar>
  );
};

export default DrawerContent;
